/**
 * Fits a value between a min and a max. If the value is between min and max, returns the value, otherwise returns the closest bound (min or max)
 */
export const fitBetween = (value: number, min: number, max: number) =>
  Math.min(Math.max(value, min), max);
